import { EscrowMemberRoleEnum } from 'src/graphql/schema';

export const roleOptions = [
  { label: 'Manager', value: EscrowMemberRoleEnum.Administrative },
  { label: 'Legal', value: EscrowMemberRoleEnum.Legal },
  { label: 'Technical', value: EscrowMemberRoleEnum.Technical },
  { label: 'Viewer', value: EscrowMemberRoleEnum.Viewer },
];

export const roleOptionsDict = roleOptions.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {},
) as Record<EscrowMemberRoleEnum, string>;
